import { render, staticRenderFns } from "./fieldPermissions.vue?vue&type=template&id=f0d45d40&scoped=true"
import script from "./fieldPermissions.vue?vue&type=script&lang=js"
export * from "./fieldPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d45d40",
  null
  
)

export default component.exports